export default "__VITE_ASSET__0FQxkajA__"